import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { communityStats } from '@/mocks/siteData';

const milestones = [
  { year: '2020', title: '社区成立', desc: '三位资深娱乐圈从业者创立91吃瓜社区，立志打造最真实的八卦爆料平台' },
  { year: '2021', title: '突破百万用户', desc: '凭借真实的爆料内容和活跃的社区氛围，注册用户突破100万，成为中文互联网最大的吃瓜社区' },
  { year: '2022', title: '每日大赛上线', desc: '推出"每日大赛"互动板块，迅速成为社区最受欢迎的栏目，日均参与投票人数超10万' },
  { year: '2023', title: '千万用户里程碑', desc: '社区用户突破1000万，月活跃用户超300万，成为娱乐八卦领域不可忽视的力量' },
  { year: '2024', title: '行业认证与合作', desc: '获得多家权威媒体认证，与20+主流娱乐媒体建立内容合作，社区公信力大幅提升' },
  { year: '2025', title: 'AI审核系统上线', desc: '引入AI内容审核系统，实现99.7%的虚假信息拦截率，进一步保障社区内容质量' },
  { year: '2026', title: '全球化布局', desc: '启动海外版测试，将吃瓜文化推向全球华语用户，用户覆盖50+国家和地区' }
];

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="pt-20 pb-12 px-4 md:px-8 min-h-screen bg-background-50">
        <div className="max-w-5xl mx-auto">
          <nav className="flex items-center gap-2 text-sm text-foreground-400 mb-8" aria-label="Breadcrumb">
            <a href="/" className="hover:text-foreground-700 transition-colors cursor-pointer">首页</a>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-600">关于我们</span>
          </nav>

          <section id="about" className="mb-16 md:mb-20">
            <h1 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 mb-6">关于91吃瓜社区</h1>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-4">
                  91吃瓜社区成立于2020年，是全网最大的吃瓜群众聚集地。我们致力于打造一个真实、有趣、有温度的娱乐八卦社区，让每一个热爱"吃瓜"的人都能在这里找到归属感。
                </p>
                <p className="text-foreground-700 text-base md:text-lg leading-relaxed mb-4">
                  在这里，你可以浏览最新最热的娱乐圈八卦、网红独家爆料、社会热点事件。我们有着严格的爆料审核机制和专业的编辑团队，确保每一条推送到你面前的内容都经过多重验证。
                </p>
                <p className="text-foreground-700 text-base md:text-lg leading-relaxed">
                  我们的口号是"黑料正能量不打烊"——在追求真相的同时，我们始终坚持传播积极向上的价值观。吃瓜不仅是一种娱乐，更是一种对真相的追求。
                </p>
              </div>
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20cozy%20community%20space%20with%20warm%20lighting%2C%20people%20chatting%20and%20laughing%20on%20comfortable%20sofas%2C%20casual%20social%20atmosphere%2C%20warm%20coral%20and%20amber%20accent%20colors%2C%20editorial%20lifestyle%20photography%2C%20inviting%20ambiance%2C%20natural%20pose&width=800&height=600&seq=about-community&orientation=landscape"
                  alt="91吃瓜社区 - 温暖的社区氛围"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </section>

          <section className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">社区数据</h2>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
              <div className="p-6 rounded-2xl bg-primary-100/70 text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-primary-600 mb-2">
                  {communityStats.totalMembers >= 10000 ? `${(communityStats.totalMembers / 10000).toFixed(0)}万+` : communityStats.totalMembers}
                </div>
                <p className="text-foreground-600 text-sm">注册用户</p>
              </div>
              <div className="p-6 rounded-2xl bg-accent-100/70 text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-accent-600 mb-2">
                  {communityStats.totalPosts >= 10000 ? `${(communityStats.totalPosts / 10000).toFixed(0)}万+` : communityStats.totalPosts}
                </div>
                <p className="text-foreground-600 text-sm">爆料帖子</p>
              </div>
              <div className="p-6 rounded-2xl bg-secondary-100/70 text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-secondary-600 mb-2">
                  {communityStats.dailyActive >= 10000 ? `${(communityStats.dailyActive / 10000).toFixed(1)}万` : communityStats.dailyActive}
                </div>
                <p className="text-foreground-600 text-sm">日活跃用户</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-200/70 text-center">
                <div className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-2">
                  {communityStats.monthlyGrowth}%
                </div>
                <p className="text-foreground-600 text-sm">月增长率</p>
              </div>
            </div>
          </section>

          <section id="milestones" className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">发展历程</h2>
            <div className="space-y-0">
              {milestones.map((m, i) => (
                <div key={m.year} className="flex gap-5 md:gap-8 pb-8 relative">
                  {i < milestones.length - 1 && (
                    <div className="absolute left-[19px] top-12 bottom-0 w-px bg-background-200"></div>
                  )}
                  <div className="w-10 h-10 flex-shrink-0 rounded-full bg-accent-500 text-background-50 flex items-center justify-center text-sm font-bold font-heading z-10">
                    {m.year.slice(2)}
                  </div>
                  <div className="pt-1.5">
                    <div className="flex items-center gap-3 mb-1.5">
                      <span className="text-xs font-semibold text-accent-600 bg-accent-100 px-2.5 py-0.5 rounded-full">{m.year}</span>
                      <h3 className="font-heading font-bold text-foreground-950 text-lg">{m.title}</h3>
                    </div>
                    <p className="text-foreground-500 text-sm md:text-base leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="reputation" className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">社区口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-6 rounded-2xl bg-background-100 border border-background-200/50">
                <div className="flex text-secondary-500 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-lg"></i>
                  ))}
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  "吃瓜这么多年，91吃瓜是所有八卦平台里信息最准的。小编们真的很用心在做内容，每条爆料都会有来源标注，这点太重要了。"
                </p>
                <p className="text-foreground-400 text-xs">— 来自App Store用户评价</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-100 border border-background-200/50">
                <div className="flex text-secondary-500 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-lg"></i>
                  ))}
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  "每日大赛太好玩了！每天蹲12点等新瓜已经成了我生活的一部分。社区氛围特别好，瓜友们都很友善，不会像微博那样撕来撕去。"
                </p>
                <p className="text-foreground-400 text-xs">— 来自社区用户"吃瓜群众小王"</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-100 border border-background-200/50">
                <div className="flex text-secondary-500 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-lg"></i>
                  ))}
                </div>
                <p className="text-foreground-700 text-sm leading-relaxed mb-4">
                  "作为媒体人，我经常在91吃瓜找选题灵感。这里的爆料速度比传统媒体快太多了，而且很多都是有实锤的，不是空穴来风。"
                </p>
                <p className="text-foreground-400 text-xs">— 来自合作媒体记者评价</p>
              </div>
            </div>
          </section>

          <section id="rules" className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">社区规范</h2>
            <div className="space-y-4">
              {[
                { title: '真实爆料', desc: '鼓励发布真实可靠的信息，严禁编造、传播虚假信息和谣言。发布虚假信息将被永久封禁账号。' },
                { title: '文明发言', desc: '尊重他人，禁止人身攻击、辱骂、歧视性言论。理性吃瓜，拒绝网络暴力。' },
                { title: '保护隐私', desc: '不得公开他人隐私信息（电话号码、住址、身份证号等），不得发布未公开的私密照片或视频。' },
                { title: '合法合规', desc: '所有发布内容必须符合中华人民共和国法律法规，严禁传播违法违规信息。' },
              ].map((rule) => (
                <div key={rule.title} className="flex gap-4 p-5 rounded-2xl bg-background-100">
                  <div className="w-8 h-8 flex-shrink-0 rounded-full bg-accent-500 text-background-50 flex items-center justify-center font-bold text-sm">
                    <i className="ri-check-line"></i>
                  </div>
                  <div>
                    <h3 className="font-heading font-bold text-foreground-950 mb-1.5">{rule.title}</h3>
                    <p className="text-foreground-500 text-sm leading-relaxed">{rule.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section id="contact" className="mb-16 md:mb-20">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">联系我们</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
              <div className="p-8 rounded-2xl bg-background-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-5">
                  <i className="ri-mail-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 text-lg mb-2">商务合作</h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-3">
                  品牌推广、广告投放、内容合作等商业合作需求，请发送邮件至：
                </p>
                <a href="mailto:business@91chigua.com" className="text-accent-600 hover:text-accent-700 font-medium text-sm">
                  business@91chigua.com
                </a>
              </div>
              <div className="p-8 rounded-2xl bg-background-100">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 mb-5">
                  <i className="ri-alert-line text-2xl"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 text-lg mb-2">内容举报</h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-3">
                  如发现违规内容或侵权行为，请通过以下方式联系我们，我们将在24小时内处理：
                </p>
                <a href="mailto:report@91chigua.com" className="text-primary-600 hover:text-primary-700 font-medium text-sm">
                  report@91chigua.com
                </a>
              </div>
            </div>

            <div className="mt-5 grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-6 rounded-2xl bg-background-100 text-center">
                <i className="ri-wechat-line text-2xl text-accent-600 mb-3 block"></i>
                <p className="text-foreground-700 text-sm font-medium">微信公众号</p>
                <p className="text-foreground-400 text-xs mt-1">91吃瓜社区</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-100 text-center">
                <i className="ri-weibo-line text-2xl text-accent-600 mb-3 block"></i>
                <p className="text-foreground-700 text-sm font-medium">新浪微博</p>
                <p className="text-foreground-400 text-xs mt-1">@91吃瓜社区</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-100 text-center">
                <i className="ri-tiktok-line text-2xl text-accent-600 mb-3 block"></i>
                <p className="text-foreground-700 text-sm font-medium">抖音账号</p>
                <p className="text-foreground-400 text-xs mt-1">91吃瓜社区</p>
              </div>
            </div>
          </section>

          <section id="faq" className="mb-8">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8">常见问题</h2>
            <div className="space-y-3">
              {[
                { q: '91吃瓜社区的爆料内容靠谱吗？', a: '我们有着严格的爆料审核机制，所有爆料内容都会经过多重交叉验证才会被推荐到首页。社区还设有"实锤认证"标签系统，经过时间验证的爆料会获得专属标识。' },
                { q: '如何在91吃瓜社区发布爆料？', a: '注册成为社区成员后，你可以在任意板块发布爆料帖子。我们鼓励大家提供真实可靠的信息来源，优质爆料帖会获得流量扶持和积分奖励。' },
                { q: '每日大赛是什么？', a: '每日大赛是91吃瓜社区最受欢迎的互动板块！每天中午12点，我们会精选当日最热的5条爆料话题进行投票PK，排名第一的话题将获得全天首页推荐位。' },
                { q: '91吃瓜社区收费吗？', a: '完全免费！91吃瓜社区始终秉持"吃瓜自由"的理念，所有公开内容均免费浏览。基础吃瓜功能永久免费开放。' },
              ].map((faq, i) => (
                <div key={i} className="p-5 rounded-2xl bg-background-100">
                  <p className="font-heading font-bold text-foreground-950 mb-2">{faq.q}</p>
                  <p className="text-foreground-600 text-sm leading-relaxed">{faq.a}</p>
                </div>
              ))}
            </div>
          </section>
        </div>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "关于91吃瓜社区",
            "description": "91吃瓜社区是全网最大的吃瓜群众聚集地，致力于打造真实、有趣、有温度的娱乐八卦社区",
            "url": "https://91chigua.com/about",
            "isPartOf": {
              "@type": "WebSite",
              "name": "91吃瓜社区",
              "url": "https://91chigua.com"
            }
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "https://91chigua.com" },
              { "@type": "ListItem", "position": 2, "name": "关于我们" }
            ]
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "91吃瓜社区的爆料内容靠谱吗？",
                "acceptedAnswer": { "@type": "Answer", "text": "91吃瓜社区有着严格的爆料审核机制，所有爆料内容都会经过多重交叉验证才会被推荐到首页。社区还设有实锤认证标签系统。" }
              },
              {
                "@type": "Question",
                "name": "如何在91吃瓜社区发布爆料？",
                "acceptedAnswer": { "@type": "Answer", "text": "注册成为社区成员后，你可以在任意板块发布爆料帖子。优质爆料帖会获得流量扶持和积分奖励。" }
              },
              {
                "@type": "Question",
                "name": "每日大赛是什么？",
                "acceptedAnswer": { "@type": "Answer", "text": "每日大赛是91吃瓜社区最受欢迎的互动板块！每天中午12点，我们会精选当日最热的5条爆料话题进行投票PK，排名第一的话题将获得全天首页推荐位。" }
              },
              {
                "@type": "Question",
                "name": "91吃瓜社区收费吗？",
                "acceptedAnswer": { "@type": "Answer", "text": "完全免费！91吃瓜社区始终秉持吃瓜自由的理念，所有公开内容均免费浏览。" }
              }
            ]
          })}
        </script>
      </main>
      <Footer />
    </>
  );
}